import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import PortalLayout, { card, StateMsg, datumTijdNL } from '../components/PortalLayout';

const A = '#00D4AA';

const TYPE_META = {
  tms_storing: { icon: '\u26A0\uFE0F', kleur: '#dc2626' },
  onderhoud_herinnering: { icon: '\uD83D\uDD27', kleur: '#0ea5e9' },
  werkorder_afgerond: { icon: '\u2705', kleur: '#16a34a' },
};

export default function Notificaties() {
  const navigate = useNavigate();
  const [lijst, setLijst] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const laad = async () => {
    try {
      const r = await api.get('/klantportaal/notificaties');
      setLijst(r.data.notificaties || []);
    } catch (e) {
      setError('Kon meldingen niet laden');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { laad(); }, []);

  const open = async (n) => {
    if (!n.gelezen) {
      try { await api.post(`/klantportaal/notificaties/${n.id}/gelezen`); } catch (e) {}
      setLijst((prev) => prev.map((x) => (x.id === n.id ? { ...x, gelezen: true } : x)));
    }
    if (n.object_id) navigate(`/object/${n.object_id}`);
  };

  const allesGelezen = async () => {
    try { await api.post('/klantportaal/notificaties/alles-gelezen'); } catch (e) {}
    setLijst((prev) => prev.map((x) => ({ ...x, gelezen: true })));
  };

  const ongelezen = lijst.filter((x) => !x.gelezen).length;

  return (
    <PortalLayout titel="Meldingen">
      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <button onClick={() => navigate('/notificatie-voorkeuren')} style={{ flex: 1, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, padding: '10px', fontSize: 14, color: '#1e293b', cursor: 'pointer' }}>Instellingen</button>
        <button onClick={allesGelezen} disabled={ongelezen === 0} style={{ flex: 1, background: ongelezen === 0 ? '#e2e8f0' : A, border: 'none', borderRadius: 10, padding: '10px', fontSize: 14, color: ongelezen === 0 ? '#94a3b8' : '#062b24', fontWeight: 600, cursor: ongelezen === 0 ? 'default' : 'pointer' }}>Alles gelezen</button>
      </div>
      <StateMsg loading={loading} error={error} leeg={!loading && !error && lijst.length === 0} leegTekst="Nog geen meldingen." />
      {lijst.map((n) => {
        const meta = TYPE_META[n.type] || { icon: '\uD83D\uDD14', kleur: '#64748b' };
        return (
          <div key={n.id} onClick={() => open(n)} style={{ ...card, cursor: n.object_id ? 'pointer' : 'default', borderLeft: `4px solid ${meta.kleur}`, opacity: n.gelezen ? 0.6 : 1, display: 'flex', gap: 12, alignItems: 'flex-start' }}>
            <div style={{ fontSize: 22, lineHeight: 1 }}>{meta.icon}</div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontWeight: 700, color: '#1e293b', fontSize: 15 }}>{n.titel}</span>
                {!n.gelezen && <span style={{ width: 8, height: 8, borderRadius: 999, background: A, flexShrink: 0 }} />}
              </div>
              {n.body && <div style={{ color: '#64748b', fontSize: 13, marginTop: 3 }}>{n.body}</div>}
              {n.object_naam && <div style={{ color: A, fontSize: 13, fontWeight: 600, marginTop: 4 }}>{n.object_naam}</div>}
              <div style={{ color: '#94a3b8', fontSize: 12, marginTop: 4 }}>{datumTijdNL(n.created_at)}</div>
            </div>
          </div>
        );
      })}
    </PortalLayout>
  );
}
